import { render } from "./model-selector-app.vue?vue&type=template&id=2bb3e168"
import script from "./model-selector-app.vue?vue&type=script&lang=js"
export * from "./model-selector-app.vue?vue&type=script&lang=js"

import "./model-selector-app.vue?vue&type=style&index=0&id=2bb3e168&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__